// extracted by mini-css-extract-plugin
export default {"Container":"UserItem_Container__G4vYB","TabBar":"UserItem_TabBar__FT0fh","Label":"UserItem_Label__a0OGW"};